/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesextractionfailedshort3Inputs */

const en_filesextractionfailedshort3 = /** @type {(inputs: Filesextractionfailedshort3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't read this file.`)
};

const pt_filesextractionfailedshort3 = /** @type {(inputs: Filesextractionfailedshort3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível ler este ficheiro.`)
};

/**
* | output |
* | --- |
* | "Couldn't read this file." |
*
* @param {Filesextractionfailedshort3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesextractionfailedshort3 = /** @type {((inputs?: Filesextractionfailedshort3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesextractionfailedshort3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesextractionfailedshort3(inputs)
	return pt_filesextractionfailedshort3(inputs)
});
export { filesextractionfailedshort3 as "filesExtractionFailedShort" }